export const OPTIONS_SYMBOL = Symbol('ws-hook-handler-options');
